<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('text.appId')">{{ form.appId }}</el-form-item>

        <el-form-item :label="$t('text.rcsIp')">
          <el-input
            v-model="form.rcsIp"
            type="text"
            size="small"
            :disabled="true"
            style="width: 550px"
          >
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('text.md5SignKey')">
          <el-input
            v-model="form.signKey"
            type="text"
            size="small"
            :disabled="true"
            style="width: 550px"
          >
          </el-input>
        </el-form-item>

        <el-form-item size="large">
          <el-button @click="resetApi">{{ $t('text.resetSignKey') }}</el-button>
          <div class="tipsInfo" style="color: #f56c6c">
            {{ $t('message.resetSignKey') }}
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      form: {
        appId: '',
        rcsIp: '',
        signKey: '',
      },
      pwdType: 'password',
    }
  },
  created() {
    this.axios.get('/merchant/getKey', { params: {} }).then(res => {
      if (res.code === 200) {
        this.form = res.data
        this.form.signKey =
          this.form.signKey.slice(0, 8) +
          '*******' +
          this.form.signKey.slice(
            this.form.signKey.length - 8,
            this.form.signKey.length
          )
        // console.log(this.form);
      }
    })
  },
  methods: {
    showPwd() {
      this.pwdType === 'password'
        ? (this.pwdType = '')
        : (this.pwdType = 'password')
    },
    resetApi() {
      this.$confirm(this.$t('message.confirmResettingSignKey'), this.$t('text.prompt'), {
        confirmButtonText: this.$t('text.confirm'),
        cancelButtonText: this.$t('text.cancel'),
        type: 'warning',
      }).then(() => {
          this.$confirm(this.$t('message.doubleConfirmResetSignKey'), this.$t('text.prompt'), {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: 'info',
          }).then(() => {

          this.axios
              .post('/merchant/resetKey', {
                params: this.form,
              })
              .then(res => {
                if (res.code === 200) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.error(res.msg);
                }
              });

          // this.axios
          //   .post('/merchant/resetKey', {
          //     params: this.form,
          //     responseType: 'blob',
          //   })
          //   .then(res => {
          //     let filename
          //     var contentDisposition = res.headers['content-disposition']
          //     var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          //     var matches = filenameRegex.exec(contentDisposition)
          //     if (matches != null && matches[1]) {
          //       filename = matches[1].replace(/['"]/g, '')
          //     }
          //     // console.log(filename)
          //
          //     // const time = new Date().getTime();
          //     let blob = new Blob([res.data], {
          //       type: 'application/vnd.ms-excel',
          //     })
          //     // 将blob对象转为一个URL
          //     var blobURL = window.URL.createObjectURL(blob)
          //     // 创建一个a标签
          //     var tempLink = document.createElement('a')
          //     // 隐藏a标签
          //     tempLink.style.display = 'none'
          //     // 设置a标签的href属性为blob对象转化的URL
          //     tempLink.href = blobURL
          //     // 给a标签添加下载属性
          //     tempLink.setAttribute('download', filename)
          //     if (typeof tempLink.download === 'undefined') {
          //       tempLink.setAttribute('target', '_blank')
          //     }
          //     // 将a标签添加到body当中
          //     document.body.appendChild(tempLink)
          //     // 启动下载
          //     tempLink.click()
          //     // 下载完毕删除a标签
          //     document.body.removeChild(tempLink)
          //     window.URL.revokeObjectURL(blobURL)
          //     this.$message({
          //       message: this.$t('message.resetSuccess'),
          //       type: 'success',
          //     })
          //   })
        }).catch(() => {})
      }).catch(() => {})
    },

    // resetApi() {
    //   this.axios.post("/merchant/resetKey", {}).then((res) => {
    //     // this.form.signKey = res.data;
    //     // this.$message.success("重置成功");
    //   });
    // },
    copy(text) {
      let clipboard = new Clipboard('.copy_api', {
        text: () => {
          return text
        },
      })
      clipboard.on('success', e => {
        this.$message.success(this.$t('message.copySuccess'))
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error(this.$t('message.copyError'))
        clipboard.destroy()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>